module.exports = __webpack_public_path__ + "img/济源市.21d4848a.png";